export const STYLES = {
  // Filter Button Styles
  filterButton: {
    borderRadius: "12px",
    fontSize: "0.875rem",
    fontWeight: 600,
  } as const,
  // Popover Styles
  popoverAnchorOrigin: {
    vertical: "bottom",
    horizontal: "right",
  } as const,
  popoverTransformOrigin: {
    vertical: "top",
    horizontal: "right",
  } as const,
  popoverRootSlotProps: {mt: 1} as const,
  popoverPaperSlotProps: {
    borderRadius: "16px",
    width: "fit-content",
    height: "fit-content",
    position: "relative",
  } as const,
  popoverFooter: {
    justifyContent: "space-between",
    gap: 1,
    px: 2.5,
    py: 2,
    borderTop: "1px solid #DDDDDD",
  } as const,
};
